// extracted by mini-css-extract-plugin
export default {"octave":"octave--1Wsd5","note":"note--3j1R4","wrapped":"wrapped--2lwcC","sharp":"sharp--30Cx_"};